<template>
  <div class="container d-flex flex-column">
    <Logged-user />
    <div v-if="loading" class="loading">
      <clip-loader />
    </div>
    <div class="row mt-4" v-else>
      <div class="col-12">
        <div class="row">
          <ul class="col-12">
            <li v-for="month in months" v-bind:key="month.getTime()"
            class="text-nowrap" v-on:click="changeMonth(month)">
              {{month.toLocaleDateString('fr-FR',{year: 'numeric', month: 'long'})}}
            </li>
          </ul>
        </div>
        <div class="row">
          <div class="col-12">
            <h2>Statistiques {{currentPeriod}}</h2><br />
            Nombre de "joueurs-parties" ce mois-ci:
            <strong>{{stats.nbGamesPlayed}}</strong>
            parties. Si un joueur fait plus de 400 pts sur une partie, il est compté.<br />
            Coût de l'hébergement ce mois ci (à date) :
            {{stats.hebergementCost}} $<br />
            Coût par partie :
            {{stats.hebergementCost}} $ / {{stats.nbGamesPlayed}} =
            <strong>{{stats.gameCost}} $</strong><br />
          </div>
        </div>
        <div class="row mt-4" >
          <div class="col-12">
            <table class="table table-stripped table-sm mt-2">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Nom</th>
                  <th>Email</th>
                  <th>Nb de parties jouées</th>
                  <th>Coût</th>
                  <th>Premium ?</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(user, index) in stats.users" v-bind:key="user.userId">
                  <td>{{index + 1}}</td>
                  <td>
                    <div class="username">
                    {{user.username}}
                    </div>
                  </td>
                  <td>{{user.email}}</td>
                  <td>{{user.nbGames}}</td>
                  <td>{{Number(user.nbGames * stats.gameCost).toFixed(4)}} $</td>
                  <td v-if="user.premium">OUI</td>
                  <td v-else>NON</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-auto">
      <bottom-nav />
    </div>
  </div>
</template>

<script>
import LoggedUser from '../LoggedUser.vue';
import BottomNav from '../BottomNav.vue';
import ClipLoader from '../ClipLoader.vue';

const padZero = n => ((n < 10) ? `0${n}` : n);

export default {
  name: 'AdminStats',
  components: { LoggedUser, BottomNav, ClipLoader },
  data() {
    return {
      stats: undefined,
      months: [],
      currentPeriod: new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'long' }),
      loading: true,
    };
  },
  created() {
    this.initMonthList();
    this.changeMonth(new Date());
  },
  methods: {
    async getStatistics(period) {
      return this.$http.get(`${import.meta.env.VITE_LCT_API_URL}/statistics?period=${period}`)
        .then(response => response.data);
    },
    initMonthList() {
      const today = new Date();
      let month = 2;
      let year = 2020;
      const months = [new Date(Date.UTC(year, month))];
      while (month !== today.getMonth() || year !== today.getFullYear()) {
        year = month === 11 ? year + 1 : year;
        month = month === 11 ? 0 : month + 1;
        months.push(new Date(Date.UTC(year, month)));
      }
      this.months = months.reverse();
    },
    toDate(timestamp) {
      const d = new Date(timestamp);
      return `${padZero(d.getDate())}/${padZero(d.getMonth() + 1)}/${d.getFullYear()}`;
    },
    async changeMonth(month) {
      this.loading = true;
      const period = `${month.getFullYear()}-${(`0${month.getMonth() + 1}`).slice(-2)}`;
      const stats = await this.getStatistics(period);
      this.currentPeriod = month.toLocaleDateString('fr-FR', { year: 'numeric', month: 'long' });
      this.stats = stats;
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.loading {
  height: 200px;
  margin-top: 30px;
}
ul{
  list-style: none;
}
ul li{
  font-size: 0.8rem;
  float: left;
  margin-right: 20px;
}
ul li:hover {
  cursor: pointer;
}
.username {
  width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
